/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * PaymentGatewayProxy.Api | v1
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  HttpValidationProblemDetails,
  SetAdyenWebhookHmacRequest,
  SystemSettingsDto,
  UpdateSystemSettingsRequest,
} from '.././schemas';

import { apiFetcher } from '../../http/apiFetcher';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Read the runtime settings singleton.
 */
export const adminSettingsGetAdminSettings = (
  options?: SecondParameter<typeof apiFetcher>,
  signal?: AbortSignal,
) => {
  return apiFetcher<SystemSettingsDto>({ url: `/admin/settings`, method: 'GET', signal }, options);
};

export const getAdminSettingsGetAdminSettingsQueryKey = () => {
  return [`/admin/settings`] as const;
};

export const getAdminSettingsGetAdminSettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminSettingsGetAdminSettings>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof adminSettingsGetAdminSettings>>, TError, TData>
  >;
  request?: SecondParameter<typeof apiFetcher>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminSettingsGetAdminSettingsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminSettingsGetAdminSettings>>> = ({
    signal,
  }) => adminSettingsGetAdminSettings(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminSettingsGetAdminSettings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminSettingsGetAdminSettingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminSettingsGetAdminSettings>>
>;
export type AdminSettingsGetAdminSettingsQueryError = unknown;

export function useAdminSettingsGetAdminSettings<
  TData = Awaited<ReturnType<typeof adminSettingsGetAdminSettings>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminSettingsGetAdminSettings>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminSettingsGetAdminSettings>>,
          TError,
          Awaited<ReturnType<typeof adminSettingsGetAdminSettings>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminSettingsGetAdminSettings<
  TData = Awaited<ReturnType<typeof adminSettingsGetAdminSettings>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminSettingsGetAdminSettings>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminSettingsGetAdminSettings>>,
          TError,
          Awaited<ReturnType<typeof adminSettingsGetAdminSettings>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminSettingsGetAdminSettings<
  TData = Awaited<ReturnType<typeof adminSettingsGetAdminSettings>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminSettingsGetAdminSettings>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Read the runtime settings singleton.
 */

export function useAdminSettingsGetAdminSettings<
  TData = Awaited<ReturnType<typeof adminSettingsGetAdminSettings>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminSettingsGetAdminSettings>>, TError, TData>
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAdminSettingsGetAdminSettingsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Patch the runtime settings (SuperAdmin only).
 */
export const adminSettingsPutAdminSettings = (
  updateSystemSettingsRequest: UpdateSystemSettingsRequest,
  options?: SecondParameter<typeof apiFetcher>,
) => {
  return apiFetcher<SystemSettingsDto>(
    {
      url: `/admin/settings`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: updateSystemSettingsRequest,
    },
    options,
  );
};

export const getAdminSettingsPutAdminSettingsMutationOptions = <
  TError = HttpValidationProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminSettingsPutAdminSettings>>,
    TError,
    { data: UpdateSystemSettingsRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminSettingsPutAdminSettings>>,
  TError,
  { data: UpdateSystemSettingsRequest },
  TContext
> => {
  const mutationKey = ['adminSettingsPutAdminSettings'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminSettingsPutAdminSettings>>,
    { data: UpdateSystemSettingsRequest }
  > = (props) => {
    const { data } = props ?? {};

    return adminSettingsPutAdminSettings(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminSettingsPutAdminSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminSettingsPutAdminSettings>>
>;
export type AdminSettingsPutAdminSettingsMutationBody = UpdateSystemSettingsRequest;
export type AdminSettingsPutAdminSettingsMutationError = HttpValidationProblemDetails;

/**
 * @summary Patch the runtime settings (SuperAdmin only).
 */
export const useAdminSettingsPutAdminSettings = <
  TError = HttpValidationProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminSettingsPutAdminSettings>>,
      TError,
      { data: UpdateSystemSettingsRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof adminSettingsPutAdminSettings>>,
  TError,
  { data: UpdateSystemSettingsRequest },
  TContext
> => {
  const mutationOptions = getAdminSettingsPutAdminSettingsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Set or rotate the platform-wide Adyen webhook HMAC key (SuperAdmin only).
 */
export const adminSettingsPutAdminSettingsAdyenWebhookHmac = (
  setAdyenWebhookHmacRequest: SetAdyenWebhookHmacRequest,
  options?: SecondParameter<typeof apiFetcher>,
) => {
  return apiFetcher<void>(
    {
      url: `/admin/settings/adyen-webhook-hmac`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: setAdyenWebhookHmacRequest,
    },
    options,
  );
};

export const getAdminSettingsPutAdminSettingsAdyenWebhookHmacMutationOptions = <
  TError = HttpValidationProblemDetails,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminSettingsPutAdminSettingsAdyenWebhookHmac>>,
    TError,
    { data: SetAdyenWebhookHmacRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminSettingsPutAdminSettingsAdyenWebhookHmac>>,
  TError,
  { data: SetAdyenWebhookHmacRequest },
  TContext
> => {
  const mutationKey = ['adminSettingsPutAdminSettingsAdyenWebhookHmac'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminSettingsPutAdminSettingsAdyenWebhookHmac>>,
    { data: SetAdyenWebhookHmacRequest }
  > = (props) => {
    const { data } = props ?? {};

    return adminSettingsPutAdminSettingsAdyenWebhookHmac(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminSettingsPutAdminSettingsAdyenWebhookHmacMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminSettingsPutAdminSettingsAdyenWebhookHmac>>
>;
export type AdminSettingsPutAdminSettingsAdyenWebhookHmacMutationBody = SetAdyenWebhookHmacRequest;
export type AdminSettingsPutAdminSettingsAdyenWebhookHmacMutationError =
  HttpValidationProblemDetails;

/**
 * @summary Set or rotate the platform-wide Adyen webhook HMAC key (SuperAdmin only).
 */
export const useAdminSettingsPutAdminSettingsAdyenWebhookHmac = <
  TError = HttpValidationProblemDetails,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminSettingsPutAdminSettingsAdyenWebhookHmac>>,
      TError,
      { data: SetAdyenWebhookHmacRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof adminSettingsPutAdminSettingsAdyenWebhookHmac>>,
  TError,
  { data: SetAdyenWebhookHmacRequest },
  TContext
> => {
  const mutationOptions = getAdminSettingsPutAdminSettingsAdyenWebhookHmacMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Clear the platform-wide Adyen webhook HMAC key — disables all inbound webhook verification.
 */
export const adminSettingsDeleteAdminSettingsAdyenWebhookHmac = (
  options?: SecondParameter<typeof apiFetcher>,
) => {
  return apiFetcher<void>({ url: `/admin/settings/adyen-webhook-hmac`, method: 'DELETE' }, options);
};

export const getAdminSettingsDeleteAdminSettingsAdyenWebhookHmacMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminSettingsDeleteAdminSettingsAdyenWebhookHmac>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminSettingsDeleteAdminSettingsAdyenWebhookHmac>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['adminSettingsDeleteAdminSettingsAdyenWebhookHmac'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminSettingsDeleteAdminSettingsAdyenWebhookHmac>>,
    void
  > = () => {
    return adminSettingsDeleteAdminSettingsAdyenWebhookHmac(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminSettingsDeleteAdminSettingsAdyenWebhookHmacMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminSettingsDeleteAdminSettingsAdyenWebhookHmac>>
>;

export type AdminSettingsDeleteAdminSettingsAdyenWebhookHmacMutationError = unknown;

/**
 * @summary Clear the platform-wide Adyen webhook HMAC key — disables all inbound webhook verification.
 */
export const useAdminSettingsDeleteAdminSettingsAdyenWebhookHmac = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminSettingsDeleteAdminSettingsAdyenWebhookHmac>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof adminSettingsDeleteAdminSettingsAdyenWebhookHmac>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions =
    getAdminSettingsDeleteAdminSettingsAdyenWebhookHmacMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
